// extracted by mini-css-extract-plugin
module.exports = {"mCurated":"fj","flipped":"gj","mainContentContainer":"hj","cta":"ij","mainContentCtaDefault":"jj","disabled":"kj","mainContentCtaWhite":"lj"};